<div layout-right-header>
  <div  class="flex-space-evenly flex-col" >
    @if (name || tag || type) {
      <table class="header-table">
        <tr>
          <td class="label">Name: </td>
          <td>
            <h4 class="item-name">{{ name }}</h4>
          </td>
          @if (disabledSource) {
            <td class="disabled-label">
              <strong
                [attr.data-testid]="'disabled-text'"
                [matTooltip]="getDisabledTooltip()"
                class="disabled-source"
                >
                {{ disabledSource }}
              </strong>
            </td>
          }
        </tr>
        @if (tag) {
          <tr>
            <td class="label">Tag: </td>
            <td>
              <h4 class="header-info" [attr.title]="tag"> {{ tag }}</h4>
            </td>
          </tr>
        }
        @if (type || subType) {
          <tr>
            @if (type) {
              <td class="label">Type: </td>
            }
            @if (type) {
              <td>
                <h4 class="header-info" [attr.type]="type"> {{ type }}</h4>
              </td>
            }
            @if (subType) {
              <div id="subtype-container">
                <td class="label">Subtype: </td>
                <td>
                  <h4 id="subtype" class="header-info" [attr.type]="subType"> {{ subType }}</h4>
                </td>
              </div>
            }
            @if (featureScope !== 'Client') {
              <td>
                <emm-locales-select
                  class="locale"
                  [languagesOnlyOfCountry]="countryCode"
                ></emm-locales-select>
              </td>
            }
          </tr>
        }
      </table>
    }
  </div>
</div>
